 <script> 

import appConfig from "@/app.config";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
  
 
export default {
  mixins: [Api, Sabit],
  props: ["Form","AnktAnketId","AnketFilterText"],
  page: {
    title: "Anket Oluştur",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {    },
  data() {
    return {
      title: this.$t("CreateAnket.Title"),
      items: [
        {
          text: this.$t("CreateAnket.Title"),
          active: true,
        },
      ],
       Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      FormData: [],
      FormJson: [], 
      DataGrafik:[],
      DataGrafikSutun:[],
      DataGrafikTable:[],
      DoluKayitSayisi:0,
      CevapSayisi:0,
      Stadartsapma:"",
      Ortalama:"",
      Medyan:"",
      GenelMemnuniyetOrani: "",
      IstatistikHesaplandi: false,
      boskayitsayisi: 0,
      TotalDoluKayıtSayısı: 0,
 
     }  
  },
  watch: {
    AnketFilterText() {
      this.HesaplaIstatistik();
    },
  },
  methods: {
    Get() {},
    Raporlama(request) {
      let data = { ...request, Data: { ...request.Data } };
      if (data.Service == "AnktAnketCevap/Raporlama" && data.Data && data.Data.Filter) {
        data.Data.Filter += this.AnketFilterText || "";
      }
      return this.ActionsPost(data);
    },
    IstatistikHesaplanabilir() {
      return this.Form.type == 'rangeslider' || (this.Form.config && this.Form.config.type == 'number');
    },
    HesaplaIstatistik() {
      this.Stadartsapma = "";
      this.Ortalama = "";
      this.Medyan = "";
      this.GenelMemnuniyetOrani = "";
      this.IstatistikHesaplandi = false;
      if (this.IstatistikHesaplanabilir()) {
        this.Statics(this.Form.Id);
      }
    },
    FormatIstatistikDeger(value, maximumFractionDigits = 2) {
      let number = Number(value);
      if (!Number.isFinite(number)) {
        return "0";
      }
      return number.toLocaleString("tr-TR", {
        minimumFractionDigits: 0,
        maximumFractionDigits,
      });
    },
    Statics(SoruId){
 
      
      let Sorgu = "select cevap ->'"+SoruId+"' ->> 'Cevap' as cevap from anktanketcevap where anketid='" + this.AnktAnketId + "' and cevap ->'"+SoruId+"' ->> 'Cevap' != ''" + (this.AnketFilterText || "");
 
      let Data = {
        filter: Sorgu,
      }; 
 this.ActionsPost({
        Service: "AnktAnketCevap/Statics",
        Data: Data,
      }).then((res) => {
        //console.log(res);
        if(res && res.Stadartsapma != null){
          this.Stadartsapma = res.Stadartsapma
          this.Ortalama = res.Ortalama
          this.Medyan = res.Medyan
          this.GenelMemnuniyetOrani = res.GenelMemnuniyetOrani
          this.IstatistikHesaplandi = true
        }
      });
    }
    
    
  },
  created() {
    this.TotalDoluKayıtSayısı = 0;
    for( var j =0; j<11; j++){ 
      var Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' ='"+j+"'"
      } 
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
           this.TotalDoluKayıtSayısı += res;
      });
      }
  },
  mounted(){ 
    this.HesaplaIstatistik();
      
 
 


    let Data = "";
  if(this.Form.type == 'input' || this.Form.type == 'date' || this.Form.type == 'time'  || this.Form.type == 'textarea' || this.Form.type == 'file'){
      
      
       let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
      } 
      this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
              //console.log(res);
              this.CevapSayisi=res;
    
      Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' !=''"
      } 
      
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          if(!res){res=0;}
          // console.log(res);
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { 
               value: res, 
               name: 'Dolu Olan Kayıt Sayısı: '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: 'Dolu Olan Kayıt Sayısı: '
            },
             { 
               value: this.CevapSayisi-res, 
               name: 'Girilmeyen Kayıt Sayısı '+(this.CevapSayisi-res)+' (%'+(((this.CevapSayisi-res)/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: 'Girilmeyen Kayıt Sayısı'
            }
           );
           this.DataGrafikTable.push(
             { Title: "Dolu Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  },
             { Title: "Yanıt vermeyenler", Value: this.CevapSayisi-res, Oran: (((this.CevapSayisi-res)/this.CevapSayisi)*100).toFixed(2)  },
           );
          });
              });
    }else if(this.Form.type == 'radiobutton' || this.Form.type == 'combobox'){
let Data = {
    Filter: "select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='" + this.AnktAnketId + "'"
};

this.Raporlama({ "Service": "AnktAnketCevap/Raporlama", "Data": Data }).then(res => {
    this.CevapSayisi = res;

    let emptyData = {
        Filter: "select COUNT(*) from anktanketcevap WHERE anketid='" + this.AnktAnketId + "' and cevap->'" + this.Form.Id + "' ->> 'Cevap' =''"
    };

    this.Raporlama({ "Service": "AnktAnketCevap/Raporlama", "Data": emptyData }).then(boskayitsayisi => {
        this.boskayitsayisi = boskayitsayisi || 0;

        let promises = [];

        for (let i = 0; i < this.Form.options.length; i++) {
            let Deger = this.Form.options[i].value;
            let index = i;

            let Data = {
                Filter: "select COUNT(*) from anktanketcevap WHERE anketid='" + this.AnktAnketId + 
                        "' and cevap->'" + this.Form.Id + "' ->> 'Cevap' ='" + this.Form.options[i].Id + "'"
            };

            promises.push(
                this.Raporlama({ "Service": "AnktAnketCevap/Raporlama", "Data": Data }).then(res => {
                    return {
                        index,
                        value: res,
                        name: Deger + ': ' + res + ' (%' + ((res / (this.CevapSayisi - boskayitsayisi)) * 100).toFixed(2) + ')',
                        namefooter: Deger,
                        title: Deger,
                        oran: ((res / (this.CevapSayisi - boskayitsayisi)) * 100).toFixed(2)
                    };
                })
            );
        }

        Promise.all(promises).then(results => {
            results.sort((a, b) => a.index - b.index);

            this.DataGrafik = results.map(r => ({
                value: r.value,
                name: r.name,
                namefooter: r.namefooter
            }));

            this.DataGrafikTable = results.map(r => ({
                Title: r.title,
                Value: r.value,
                Oran: r.oran
            }));
        });
    });
});


    }else if(this.Form.type == 'rangeslider' && this.TotalDoluKayıtSayısı != null){
           let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
      } 
   this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          //console.log(res);
           this.CevapSayisi=res;
      for( var j =0; j<11; j++){ 
      Data={
        Filter:"select COUNT(*)  from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and cevap->'"+this.Form.Id+"' ->> 'Cevap' ='"+j+"'"
      } 
     
      const Name = j + " Kayıt Sayısı" 
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          // console.log(res);
          
           
           this.DataGrafik.push(
             { value: res, 
              name: Name+': '+res+' (%'+((res/this.TotalDoluKayıtSayısı)*100).toFixed(2)+')',
               namefooter: Name
              }
           );
           this.DataGrafikTable.push(
             { Title: Name, Value: res, Oran: ((res/this.TotalDoluKayıtSayısı)*100).toFixed(2)  }
           );
      });
      }
      
      });
    }else if(this.Form.type == 'CoktanSecmeliTablo') {
    let Data = {
        Filter: "select COUNT(id) from anktanketcevap WHERE anketid='" + this.AnktAnketId + "'"
    };
    
    this.Raporlama({ "Service": "AnktAnketCevap/Raporlama", "Data": Data }).then(res => {
        this.CevapSayisi = res;
        
        let promises = [];
        
        for (let i = 0; i < this.Form.options.Satir.length; i++) {
            for (let j = 0; j < this.Form.options.Sutun.length; j++) {
                let SatirId = this.Form.options.Satir[i].Id;
                let SutunId = this.Form.options.Sutun[j].Id;
                let indexSatir = i;
                let indexSutun = j;
                
                let Data = {
                    Filter: "select COUNT(id) from anktanketcevap WHERE anketid='" + this.AnktAnketId +
                            "' and cevap->'" + this.Form.Id + "'->'Cevap'->>'" + SatirId + "' = '" + SutunId + "'"
                };
                
                promises.push(
                    this.Raporlama({ "Service": "AnktAnketCevap/Raporlama", "Data": Data }).then(res => {
                        return {
                            indexSatir,
                            indexSutun,
                            Id: SatirId,
                            value: res,
                            name: this.Form.options.Sutun[j].value + ': ' + res + ' (%' + ((res / this.CevapSayisi) * 100).toFixed(2) + ')',
                            namefooter: this.Form.options.Sutun[j].value,
                            title: this.Form.options.Sutun[j].value,
                            oran: ((res / this.CevapSayisi) * 100).toFixed(2)
                        };
                    })
                );
            }
        }
        
        Promise.all(promises).then(results => {
            results.sort((a, b) => (a.indexSatir - b.indexSatir) || (a.indexSutun - b.indexSutun));
            
            this.DataGrafik = results.map(r => ({
                Id: r.Id,
                value: r.value,
                name: r.name,
                namefooter: r.namefooter
            }));
            
            this.DataGrafikTable = results.map(r => ({
                Id: r.Id,
                Title: r.title,
                Value: r.value,
                Oran: r.oran
            }));
        });
    });
}

    
    else if(this.Form.type == 'OnayKutuluTablo'){
        Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' "
      }  
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
         
     this.CevapSayisi = res
          
      for(let i =0; i<this.Form.options.Satir.length; i++){
        for(let j =0; j<this.Form.options.Sutun.length; j++){
 
 
        Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and (cevap->'"+this.Form.Id+"'->'Cevap'->'"+this.Form.options.Satir.[i].Id+"'->>'"+this.Form.options.Sutun.[j].Id+"')::boolean is true"
      }  
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
         
          // console.log(res); 
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { Id: this.Form.options.Satir[i].Id,value: res,  
                name: this.Form.options.Sutun[j].value+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: this.Form.options.Sutun[j].value
             }
           );
           this.DataGrafikTable.push(
             { Id: this.Form.options.Satir[i].Id,Title:  this.Form.options.Sutun[j].value +" Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           );

          
      });
      }

    }
     });
    }
    
    else if(this.Form.type == 'checkbox' ){ 
      let Data={
        Filter:"select COUNT(*) as DoluKayitSayisi from anktanketcevap WHERE anketid='"+this.AnktAnketId+"'"
      } 
       
   this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => { 
          //console.log(res);
           this.CevapSayisi=res;

      for(let i =0; i<this.Form.options.length; i++){
        let Deger =this.Form.options[i].value
      Data={
        Filter:"select COUNT(id) from anktanketcevap WHERE anketid='"+this.AnktAnketId+"' and (cevap->'"+this.Form.Id+"'->'Cevap'->>'"+this.Form.options[i].Id+"')::boolean is true"
      }  
       this.Raporlama({"Service":"AnktAnketCevap/Raporlama","Data":Data}).then(res => {  
          // console.log(res); 
          this.DoluKayitSayisi=res
           this.DataGrafik.push(
             { value: res,  
             name: Deger +' Kayıt Sayısı'+': '+res+' (%'+((res/this.CevapSayisi)*100).toFixed(2)+')',
               namefooter: Deger +" Kayıt Sayısı"
               }
           );
           this.DataGrafikTable.push(
             { Title: Deger+" Kayıt Sayısı", Value: res, Oran: ((res/this.CevapSayisi)*100).toFixed(2)  }
           );
        
      });   
      }});
     }  
  }, 

  computed: {
  SortedDataGrafikTable() {
    return [...this.DataGrafikTable].sort((a, b) => {
      const aNum = parseInt((a.Title || "").match(/^\d+/)?.[0] ?? 0, 10);
      const bNum = parseInt((b.Title || "").match(/^\d+/)?.[0] ?? 0, 10);
      return aNum - bNum;
    });
  },

  SortedDataGrafik() {
    return [...this.DataGrafik].sort((a, b) => {
      const aNum = parseInt((a.namefooter || "").match(/^\d+/)?.[0] ?? 0, 10);
      const bNum = parseInt((b.namefooter || "").match(/^\d+/)?.[0] ?? 0, 10);
      return aNum - bNum;
    });
  }
}
};
</script>
<style >
.dropdown-menu.show {
  overflow-y: scroll !important;
  height: 200px !important;
}
</style>
<template>
  <tbody>
    <template v-if="Form.type != 'OnayKutuluTablo' && Form.type != 'CoktanSecmeliTablo'">
      <tr>
        <td colspan="4">
          {{ $t("AnktDetay.Page.YanitlarTab.Soru") }} {{ Form.props.title }}
        </td>
      </tr>
      <tr v-if="DataGrafikTable.length != 0">
        <td></td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Alan") }}</td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Deger") }}</td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Oran") }}</td>
      </tr>
      <tr
        v-for="(GrafikTable, GrafikTableIndex) in SortedDataGrafikTable"
        :key="GrafikTableIndex"
      >
        <td></td>
        <td>{{ GrafikTable.Title }}</td>
        <td>{{ GrafikTable.Value }}</td>
        <td>% {{ GrafikTable.Oran | formatYuzde }}</td>
      </tr>
      <template v-if="IstatistikHesaplanabilir() && IstatistikHesaplandi">
        <tr>
          <td></td>
          <td>{{ $t("AnktDetay.Page.YanitlarTab.GenelMemnuniyetOrani") }}</td>
          <td>%{{ FormatIstatistikDeger(GenelMemnuniyetOrani) }}</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t("AnktDetay.Page.YanitlarTab.StadartSapma") }}</td>
          <td>{{ FormatIstatistikDeger(Stadartsapma, 6) }}</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t("AnktDetay.Page.YanitlarTab.Ortalama") }}</td>
          <td>{{ FormatIstatistikDeger(Ortalama) }}</td>
          <td></td>
        </tr>
        <tr>
          <td></td>
          <td>{{ $t("AnktDetay.Page.YanitlarTab.Medyan") }}</td>
          <td>{{ FormatIstatistikDeger(Medyan) }}</td>
          <td></td>
        </tr>
      </template>
    </template>

    <template v-if="Form.type == 'OnayKutuluTablo' || Form.type == 'CoktanSecmeliTablo'">
      <div v-for="(Satirlar, index) in Form.options.Satir" :key="'satir-' + index">
       <tr :key="'satir-' + index">
        <td colspan="4">
          {{ $t("AnktDetay.Page.YanitlarTab.Soru") }}
          {{ Form.props.title }} / {{ Satirlar.value }}
        </td>
      </tr>
      <tr v-if="DataGrafikTable.length != 0">
        <td></td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Alan") }}</td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Deger") }}</td>
        <td>{{ $t("AnktDetay.Page.YanitlarTab.Oran") }}</td>
      </tr>
      <tr
        v-for="(GrafikTable, GrafikTableIndex) in SortedDataGrafikTable.filter(
          (item) => item.Id === Satirlar.Id
        )"
        :key="GrafikTableIndex"
      >
        <td></td>
        <td>{{ GrafikTable.Title }}</td>
        <td>{{ GrafikTable.Value }}</td>
        <td>% {{ GrafikTable.Oran | formatYuzde }}</td>
      </tr>
          </div>
    </template>
  </tbody>
</template>

